import * as React from "react";
import { ReactElement, ReactNode } from "react";

import TooltipComponent from "./TooltipComponent";
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
library.add(faQuestionCircle);

interface Props {
  children: ReactNode,
}

function HelpTooltip({children}: Props) {
  const element: ReactElement = (
    <span className="ll-help-tooltip">
      <FontAwesomeIcon icon="question-circle" />
    </span>
  )
  return (
    <TooltipComponent
      element={element}
      tooltip={children}
      uncontrolled
    />
  );
}

export default HelpTooltip;
